import React, { Component } from 'react';
import moment from 'moment';
import ContentLoading from '../widgets/content_loading';

import './entries_style.scss';

// sort function for entry dates
const entryTimestampSort = (entryA, entryB) => {
    return (
        moment(entryB.entry_date).format('X') -
        moment(entryA.entry_date).format('X')
    );
};

// generic function to group a list of items by a key
const groupBy = function(list, key) {
    return list.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

class Entries extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.actions.entryActions.getEntries();
    }

    render() {
        const { entries, drawings } = this.props.entry;

        const activeDrawings = drawings.filter(drawing => {
            return moment().isBetween(drawing.start_date, drawing.end_date);
        });

        const drawEntries = entries => {
            if (entries.length === 0) {
                return (
                    <tbody>
                        <tr key="0">
                            <td data-title="Entries" colSpan="3">
                                <em>No entries submitted.</em>
                            </td>
                        </tr>
                    </tbody>
                );
            } else {
                // note we are spreading entries into a new array so we don't mutate the
                // entries array in state
                return (
                    <tbody>
                        {[...entries]
                            .sort(entryTimestampSort)
                            .map(
                                ({
                                    entryNumber,
                                    ticket_number,
                                    entry_date_local_tz,
                                    points,
                                    bonus,
                                    bonus_display,
                                }) => {
                                    return (
                                        <tr key={entryNumber}>
                                            <td data-title="Entry Number">
                                                {ticket_number}
                                            </td>
                                            <td data-title="Date &amp; Time">
                                                {moment(
                                                    entry_date_local_tz
                                                ).format('M/D/YYYY h:mm a')}
                                            </td>
                                            <td data-title="Entries Awarded">
                                                <span className="bonus-display">
                                                    {bonus_display}
                                                </span>
                                                {points}
                                            </td>
                                        </tr>
                                    );
                                }
                            )}
                    </tbody>
                );
            }
        };

        const groupedEntries = () => {
            let groups = groupBy(entries, 'draw_number');
            return activeDrawings.map(drawing => {
                if (groups[drawing.draw_number]) {
                    return groups[drawing.draw_number].reduce(
                        (total, entry) => {
                            const bonus_value = entry.bonus ?? 0;
                            return (
                                total +
                                entry.points * entry.multiplier +
                                parseInt(bonus_value)
                            );
                        },
                        0
                    );
                } else {
                    return 0;
                }
            });
        };

        const total = () => {
            let totals = entries.reduce((sum, current) => {
                const bonus_value = current.bonus ?? 0;
                return (
                    sum +
                    current.points * current.multiplier +
                    parseInt(bonus_value)
                );
            }, 0);
            return <div className="total">TOTAL ENTRIES: {totals}</div>;
        };

        const totalCounters = () => {
            let gEntries = groupedEntries();
            return (
                <div className="info">
                    {activeDrawings.map((drawing, index) => {
                        return (
                            <p
                                key={drawing.draw_number}
                                className="total-entries"
                            >
                                ENTRIES IN DRAW {drawing.draw_number}:{' '}
                                {gEntries[index]}
                            </p>
                        );
                    })}
                </div>
            );
        };

        const entrylist = drawEntries(entries);

        return (
            <div className="entries">
                <ContentLoading hasIcon={true} loadedAction="getEntries">
                    <div className="row entries">
                        <div className="col-sm-10 col-sm-offset-1">
                            {total()}
                            {totalCounters()}
                            <table id="entryTable" className="entry-table">
                                <thead>
                                    <tr>
                                        <th width="200">Entry Number</th>
                                        <th width="200">Date &amp; Time</th>
                                        <th width="200">Entries Awarded</th>
                                    </tr>
                                </thead>
                                {entrylist}
                            </table>
                        </div>
                    </div>
                </ContentLoading>
            </div>
        );
    }
}

export default Entries;
